import {FirebaseMessaging, NotificationActionPerformedEvent, NotificationReceivedEvent} from '@capacitor-firebase/messaging';

const checkPermissions = async () => {
    const result = await FirebaseMessaging.checkPermissions();
    return result.receive;
};

const requestPermissions = async () => {
    const result = await FirebaseMessaging.requestPermissions();
    return result.receive;
};

const getToken = async () => {
    const result = await FirebaseMessaging.getToken();
    return result.token;
};

const deleteToken = async () => {
    await FirebaseMessaging.deleteToken();
};

const getDeliveredNotifications = async () => {
    const result = await FirebaseMessaging.getDeliveredNotifications();
    return result.notifications;
};

const removeDeliveredNotifications = async () => {
    await FirebaseMessaging.removeDeliveredNotifications({
        notifications: [
            {
                id: '798dfhliblqew89pzads',
            },
        ],
    });
};

const removeAllDeliveredNotifications = async () => {
    await FirebaseMessaging.removeAllDeliveredNotifications();
};

const subscribeToTopic = async (topic: string) => {
    return await FirebaseMessaging.subscribeToTopic({topic: topic});
};

const unsubscribeFromTopic = async (topic: string) => {
    return await FirebaseMessaging.unsubscribeFromTopic({topic: topic});
};

const addTokenReceivedListener = async () => {
    await FirebaseMessaging.addListener('tokenReceived', event => {
        console.log('tokenReceived', JSON.stringify({event}));
    });
};

const addNotificationReceivedListener = async (func: (event: NotificationReceivedEvent) => void) => {
    await FirebaseMessaging.addListener('notificationReceived', func);
};

const addNotificationActionPerformedListener = async (func: (event: NotificationActionPerformedEvent) => void) => {
    await FirebaseMessaging.addListener('notificationActionPerformed', func);
};

const removeAllListeners = async () => {
    await FirebaseMessaging.removeAllListeners();
};

const pushNotifications = {
    checkPermissions,
    requestPermissions,
    getToken,
    deleteToken,
    getDeliveredNotifications,
    removeDeliveredNotifications,
    removeAllDeliveredNotifications,
    subscribeToTopic,
    unsubscribeFromTopic,
    addTokenReceivedListener,
    addNotificationReceivedListener,
    addNotificationActionPerformedListener,
    removeAllListeners,
};

export default pushNotifications;
